import { useEffect } from 'react';

/**
 * Starts the webcam when the component becomes visible
 */
export function useWebcamStart(isVisible: boolean, startWebcam: () => Promise<void>) {
	useEffect(() => {
		if (isVisible) {
			startWebcam().catch(() => {
				// Webcam start failed, ignore silently
			});
		}
	}, [isVisible, startWebcam]);
}
